<template>
  <tr>
    <td :colspan="colspan">
      <v-expansion-panels flat>
        <v-expansion-panel>
          <v-expansion-panel-header class="hasAlarm" :hide-actions="true">
            <div @click="$emit('openAlarm', item)">
              <AlarmBorder :item="item" height="44px" showIcon @hasAlarm="hasAlarm = true" />
            </div>
            <v-flex xs1 sm2>
              <OnlineState v-if="stateAlarm" :data="stateAlarm" />
              <span v-else>-</span>
            </v-flex>
            <!-- need a better implementation in case there is no state -->
            <div
              :class="hasStateText ? 'd-flex justify-space-around' : 'd-flex justify-space-between'"
            >
              <div class="a-text justify-start pr-15">{{ item.name }}</div>
              <div class="a-realtime text-end pr-2">{{ secondItem }}</div>
            </div>
            <v-btn
              style="position: absolute; right: 5px"
              icon
              small
              outlined
              color="primaryLight"
              :disabled="!isValidLink"
              :to="link"
            >
              <v-icon size="16">arrow_forward</v-icon>
            </v-btn>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-for="(data, i) in columnsData" :key="i" class="panel-row">
              <span class="a-text pt-1">
                {{ data.text }}
              </span>
              <span v-if="isRealtime(data.value)">
                <tooltip-realtime :data="data.value">
                  <span class="a-realtime">
                    {{ data.value.getValue() }}
                  </span>
                </tooltip-realtime>
              </span>
              <span v-else>
                {{ data.value }}
              </span>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </td>
  </tr>
</template>

<script>
import OnlineState from "@/components/State/OnlineState.vue";
import { typeChecking } from "@/components/mixins/typeChecking.js";
import AlarmBorder from "@/components/Alarms/AlarmBorder.vue";

export default {
  components: {
    OnlineState,
    AlarmBorder,
  },
  props: {
    columns: Array,
    item: Object,
    hasStateText: Boolean,
  },
  mixins: [typeChecking],
  data: () => ({
    columnsData: [],
    hasAlarm: false,
    routePlant: "plants",
    link: "",
  }),

  watch: {
    item: {
      immediate: true,
      handler(val) {
        this.createListFromObject(val);
        this.setButtonLink(val);
      },
    },
  },
  computed: {
    secondItem() {
      if (!this.item || this.columns.length < 3) return "-";
      const { value } = this.columns[3];
      const measurement = this.item[value];
      if (measurement && this.isRealtime(measurement)) {
        return measurement.getValue();
      }
      return "-";
    },
    stateKey() {
      let stateKey;
      const keys = Object.keys(this.item);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (key.toLowerCase().includes("state")) {
          stateKey = key;
          break;
        }
      }
      return stateKey || "state";
    },
    stateAlarm() {
      if (this.stateKey in this.item) {
        return this.item[this.stateKey];
      }
      return undefined;
    },
    isValidLink() {
      return !!this.link && typeof this.link === "string";
    },
    colspan() {
      if (this.item && this.stateKey in this.item) {
        return 4;
      }
      return 3;
    },
  },
  methods: {
    createListFromObject(item) {
      const headers = [...this.columns].filter((e, i) => i > 1);
      let list = [];
      headers.forEach((header) => {
        let { text, value } = header;
        let base = { text, value: "-" };
        if (Object.hasOwnProperty.call(item, value)) {
          base.value = item[value];
        }
        list.push(base);
      });
      this.columnsData = list;
    },
    setButtonLink(item) {
      const { id, sourceType } = item;
      this.link = `${this.routePlant}/${sourceType}/${id}`;
    },
  },
};
</script>

<style scoped>
.panel-row {
  display: flex;
  justify-content: space-between;
  padding: 5px;
}
.hasAlarm {
  min-width: 92vw;
  display: grid;
  grid-template-columns: 10% 15% 50% 20%;
  padding: 1px 23px 1px 0px !important;
}
.v-btn {
  border-radius: 4px;
}
</style>
